import React from "react";
import SortingVisualizer from "./SortingVisualizer/SortingVisualizer";

function App() {
  return (
    <SortingVisualizer />
  );
}

export default App;
